// extracted by css-extract-rspack-plugin
export default {"content":"APluVCFerwk5vD5k__content___","title":"bTHPOy2okjMJE78U__title___","overlay":"ASkLsh__uSM3g_QK__overlay___"};